export const decimalToAmericanOdds = (value, fallback = '-') => {
    const decimal = Number(value);

    if (!Number.isFinite(decimal) || decimal <= 1) {
        return fallback;
    }

    if (decimal >= 2) {
        return `+${Math.round((decimal - 1) * 100)}`;
    }

    return `${Math.round(-100 / (decimal - 1))}`;
};

export const probabilityToAmericanOdds = (value, fallback = '-') => {
    const probability = Number(value);

    if (!Number.isFinite(probability) || probability <= 0 || probability >= 1) {
        return fallback;
    }

    if (probability >= 0.5) {
        return `-${Math.round((probability / (1 - probability)) * 100)}`;
    }

    return `+${Math.round(((1 - probability) / probability) * 100)}`;
};
